function mapReviewPhotos(photos) {
  return photos.map(({ sizes: { thumbnail, normal } }) => ({
    thumbnailUrl: thumbnail.url,
    fullSizeUrl: normal.url,
  }));
}

export function reviewMapper(result) {
  const {
    id,
    rating,
    title,
    reviewText,
    translatedTitle,
    translatedReviewText,
    contentLocale,
    translationEnabled,
    submissionRecency,
    syndicationSource,
    badgesOrder,
    badges,
    additionalFields,
    photos = [],
  } = result;

  return {
    id,
    rating,
    title,
    reviewText,
    translatedTitle,
    translatedReviewText,
    contentLocale,
    translationEnabled,
    submissionRecency,
    syndicationSource,
    badgesOrder,
    badges,
    dateOfUserExperience: additionalFields?.DateOfUserExperience?.value ?? null,
    dateOfUserExperienceLabel:
      additionalFields?.DateOfUserExperience?.label ?? null,
    photos: mapReviewPhotos(photos),
  };
}
